import { render, staticRenderFns } from "./AssignedAgentsSection.vue?vue&type=template&id=cb5d3744&"
import script from "./AssignedAgentsSection.vue?vue&type=script&lang=js&"
export * from "./AssignedAgentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb5d3744')) {
      api.createRecord('cb5d3744', component.options)
    } else {
      api.reload('cb5d3744', component.options)
    }
    module.hot.accept("./AssignedAgentsSection.vue?vue&type=template&id=cb5d3744&", function () {
      api.rerender('cb5d3744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/AssignedAgentsSection.vue"
export default component.exports